<template>
  <div style="background-color: #f8f8f8;width:100%">
    <section>
      <header-generic> </header-generic>
    </section>
    <section>
      <search-generic :showCambiarFlujo="showCambiarFlujo">
        <template slot="sucursal">
          <b-form-select
            class="border-none"
            v-model="selectedStoreM"
            :options="optionStoresM"
          >
            <template #first>
              <b-form-select-option :value="null" disabled
                >Seleccione la sucursal</b-form-select-option
              >
            </template>
          </b-form-select>
        </template>
        <template slot="params">
          <b-form-input
            v-on:keyup.enter="searchClient"
            class="border-none section__filter-small"
            v-model.trim="filter.valueDocument"
            placeholder="Ingresa un DNI, RUC o CE"
          ></b-form-input>
        </template>
        <template slot="button">
          <b-button
            :disabled="isEnableSearch"
            @click="searchClient"
            class="rounded-button border-none"
          >
            <font-awesome-icon icon="search" />
          </b-button>
        </template>
      </search-generic>
    </section>
    <template v-if="!Object.keys(dataClient).length">
      <div-generic />
    </template>
    <template v-else>
      <section>
        <b-container class="padding-lr-none">
          <b-row>
            <b-col cols="12" class="padding-three-tb">
              <h5 class="title__name text-large">
                Resultado Datos del cliente
              </h5>
            </b-col>
          </b-row>
        </b-container>
      </section>
      <section>
        <b-container class="bg-white padding-ten-all">
          <b-row>
            <b-col cols="12" md="4" lg="4">
              <label class="text-medium color-ligth-gray"
                >Nombre Completo</label
              >
              <span>
                {{ fullName }}
              </span>
            </b-col>
            <b-col cols="12" md="4" lg="4">
              <label class="text-medium color-ligth-gray"
                >Documento de identidad</label
              >
              <span>
                {{ dataClient.identityDocument }}
              </span>
            </b-col>
            <b-col cols="12" md="4" lg="4">
              <label class="text-medium color-ligth-gray"
                >Teléfono Principal</label
              >
              <span v-if="selectedPhone"> {{ selectedPhone.contact }}</span>
              <b-button
                class="btn-rounded-orange border-none"
                v-b-modal.modal-phone
              >
                EDITAR
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="4" lg="4">
              <label class="text-medium color-ligth-gray"
                >Teléfono Secundario</label
              >
              <span v-if="selectedPhoneSec">
                {{ selectedPhoneSec.contact }}</span
              >
              <b-button
                class="btn-rounded-orange border-none"
                v-b-modal.modal-phone-secondary
              >
                EDITAR
              </b-button>
            </b-col>
            <b-col cols="12" md="4" lg="4">
              <label class="text-medium display-block color-ligth-gray"
                >Correo</label
              >
              <span v-if="selectedEmail"> {{ selectedEmail.contact }}</span>
              <b-button
                class="btn-rounded-orange border-none"
                v-b-modal.modal-email
              >
                EDITAR
              </b-button>
            </b-col>
            <b-col cols="12" md="4" lg="4">
              <label class="text-medium color-ligth-gray">Departamento</label>
              <span v-if="selectedDirection"
                >{{ selectedDirection.department }}
              </span>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="4" lg="4">
              <label class="text-medium color-ligth-gray">Provincia</label>
              <span class="padding-four-top" v-if="selectedDirection"
                >{{ selectedDirection.province }}
              </span>
            </b-col>
            <b-col cols="12" md="4" lg="4">
              <label class="text-medium color-ligth-gray">Distrito </label>
              <span class="padding-four-top" v-if="selectedDirection"
                >{{ selectedDirection.district }}
              </span>
            </b-col>
            <b-col cols="12" md="4" lg="4">
              <label class="text-medium color-ligth-gray">Dirección </label>

              <span class="padding-four-top" v-if="selectedDirection"
                >{{ selectedDirection.street }}
                {{ selectedDirection.number }}</span
              >
              <b-button
                class="btn-rounded-orange border-none"
                v-b-modal.modal-dir
              >
                EDITAR
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="4" lg="4">
              <label class="text-medium color-ligth-gray">Referencia</label>
              <span class="padding-four-top" v-if="selectedDirection"
                >{{ selectedDirection.reference }}
              </span>
            </b-col>
            <b-col cols="2" md="4">
              <label class="text-medium color-ligth-gray" for="input-small">
                Dep./Int./Lt.
              </label>
              <span class="padding-four-top" v-if="selectedDirection">
                {{ selectedDirection.numDepartament }}
              </span>
            </b-col>
            <b-col cols="2" md="4">
              <label class="text-medium color-ligth-gray" for="input-small">
                Nro./Mz./Bloq.
              </label>
              <span class="padding-four-top" v-if="selectedDirection">
                {{ selectedDirection.numberAdress }}
              </span>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="2" md="4">
              <label class="text-medium color-ligth-gray" for="input-small">
                Piso
              </label>
              <span class="padding-four-top" v-if="selectedDirection">
                {{ selectedDirection.numFloor }}
              </span>
            </b-col>
          </b-row>
        </b-container>
      </section>
      <section class="padding-two-top">
        <b-container>
          <b-row>
            <details-orders
              v-for="(data, index) in dataManual"
              v-bind:index="index"
              v-bind:key="index"
              :typeSku.sync="typeSku"
              :descriptionSkuProduct.sync="data.descriptionSkuProduct"
              :descriptionSku.sync="data.descriptionSku"
              :quantity.sync="data.quantity"
              :turn.sync="data.turn"
              :skuProduct.sync="data.skuProduct"
              :skuService.sync="data.skuService"
              :estimatedDate.sync="data.estimatedDate"
              :restrictedDaysM="restrictedDaysM"
              :providerId.sync="data.providerId"
              :providerName.sync="data.providerName"
              :providerObservation.sync="data.providerObservation"
              :selectedStoreM="selectedStoreM"
              :optionsProviderM.sync="optionsProviderM"
              :showModalProvider.sync="showModalProvider"
              :isBusyM.sync="isBusyM"
              :state.sync="data.state"
              :voucher.sync="data.voucher"
              :folioVoucher.sync="data.folioVoucher"
              :indexModal="index"
              :rowIndex.sync="rowIndex"
              :request.sync="request"
              :messageEstimation.sync="messageEstimation"
              v-on:remove="dataManual.splice(index, 1)"
            >
            </details-orders>

            <b-col xs="12" sm="12" md="4" lg="4" class="padding-left-none">
              <div class="bg-white section__border-radius padding-all-twenty">
                <b-button
                  @click="addDetailOS"
                  class="bg-transparent border-none"
                >
                  <font-awesome-icon icon="plus" class="color-orange" />
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </section>
      <section class="margin-two-top">
        <observation-input v-model="clientObservation"></observation-input>
      </section>
      <section class="margin-two-tb">
        <b-container class="padding-lr-none">
          <b-row v-if="isVisibleMsgError">
            <b-col cols="12">
              <ul>
                <li v-show="isVisibleMsgPhone">
                  Ingresa el teléfono del cliente
                </li>
                <li v-show="isVisibleMsgEmail">
                  Ingresa el correo del cliente
                </li>
                <li v-show="isVisibleMsgDirection">
                  Ingresa la dirección del cliente
                </li>
              </ul>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" class="text-center">
              <b-button
                :disabled="isDisabledBtn"
                class="border-none btn-rounded-orange"
                @click="showConfirmBox"
                >CREAR OS</b-button
              >
            </b-col>
          </b-row>
        </b-container>
      </section>
    </template>
    <div>
      <!-- modal opciones sku prod-->
      <b-modal
        id="modal-options-v1"
        size="sm"
        hide-header-close
        hide-footer
        ok-only
        centered
        no-stacking
      >
        <modal-generic>
          <template slot="button-search">
            <b-button
              class="btn-transparent-orange border-none"
              @click="openOptionSelected"
            >
              BUSCAR
            </b-button>
          </template>
          <template slot="button-cancel">
            <b-button
              class="btn-transparent-red border-none"
              @click="$bvModal.hide('modal-options-v1')"
            >
              CANCELAR
            </b-button>
          </template>
        </modal-generic>
      </b-modal>
      <b-modal id="modal-product" hide-footer title="Seleccionar SKU">
        <modal-sku-products @rowSkuSelected="setSelectedProduct" />
      </b-modal>
      <b-modal
        id="modal-cp"
        centered
        size="lg"
        hide-footer
        title="Búsqueda por TRX"
      >
        <modal-sku-comp @rowSelectedSku="setSkuCp" />
      </b-modal>
      <b-modal
        @hidden="onHiddenModalOs"
        no-close-on-esc
        no-close-on-backdrop
        hide-footer
        id="modal-os"
        centered
        ok-only
        content-class="text-center"
      >
        <ModalOS>
          <template slot="body">
            <template v-if="!hasError">
              <p class="my-4 text-center">
                Los datos fueron completados correctamente. La OS se encuentra
                en estado Pendiente de creación.
              </p>
              <p class="my-4 text-center">
                Orden de servicio N°: {{ messageOS }}
              </p>
              <b-button class="bg-orange" @click="reset"> OK </b-button>
            </template>
            <template v-else>
              <p>{{ messageOS }}</p>
              <b-button class="bg-orange" @click="resetError"> OK </b-button>
            </template>
          </template>
        </ModalOS>
      </b-modal>

      <b-modal
        hide-footer
        id="modal-register-client"
        title="Registro de nuevo cliente"
      >
        <register-client
          @setShow="setValuesClient"
          :documentClient.sync="filter.valueDocument"
        >
        </register-client>
      </b-modal>
      <b-modal
        v-model="showModalProvider"
        @hidden="onHidden"
        hide-footer
        id="info-modal-provider"
        title="Seleccionar Proveedor"
      >
        <modal-provider
          :messageEstimation="messageEstimation"
          :isBusy="isBusyM"
          :optionsProvider="optionsProviderM"
          @rowProviderSelected="selectRowProvider"
        >
        </modal-provider>
      </b-modal>
      <b-modal
        size="lg"
        hide-footer
        class="modal-tit"
        id="modal-phone"
        title="Registro de teléfonos"
      >
        <mantenedor-telefono
          :id="dataClient.id"
          :phones="dataClient.phones"
          :selectedPhone.sync="selectedPhone"
          @update="addNewPhone"
        >
        </mantenedor-telefono>
      </b-modal>
      <b-modal
        size="lg"
        hide-footer
        class="modal-tit"
        id="modal-phone-secondary"
        title="Registro de teléfonos"
      >
        <mantenedor-telefono
          :id="dataClient.id"
          :phones="dataClient.phones"
          :selectedPhone.sync="selectedPhoneSec"
          @update="addNewPhoneSec"
        >
        </mantenedor-telefono>
      </b-modal>
      <b-modal
        size="lg"
        hide-footer
        class="modal-tit"
        id="modal-email"
        title="Registro de correos"
      >
        <mantenedor-correo
          :id="dataClient.id"
          :mails="dataClient.mails"
          :selectedEmail.sync="selectedEmail"
          @update="addNewMail"
        >
        </mantenedor-correo>
      </b-modal>
      <b-modal
        size="xl"
        hide-footer
        class="modal-tit"
        id="modal-dir"
        title="Registro de direcciones"
      >
        <modal-direcciones
          :id="dataClient.id"
          :directions="dataClient.directions"
          :selectedDirection.sync="selectedDirection"
          @update="addNewDirection"
        >
        </modal-direcciones>
      </b-modal>
    </div>
  </div>
</template>
<script>
import ModalOS from "../../components/ModalOS";
import RegisterClient from "../../components/CrearOS/RegisterClient";
import HeaderGeneric from "../../components/CrearOS/HeaderGeneric.vue";
import SearchGeneric from "../../components/CrearOsManual/SearchGeneric.vue";
import ObservationInput from "../../components/CrearOsManual/ObservationInput.vue";
import ModalGeneric from "../../components/ModalGeneric.vue";
import DivGeneric from "../../components/CrearOsManual/DivGeneric.vue";
import ModalSkuComp from "../../components/CrearOsManual/ModalSkuComp.vue";
import ModalProvider from "../../components/CrearOS/ModalProvider.vue";
import DetailsOrders from "../../components/CrearOS/DetailsOrders.vue";
import axios from "axios";
import { mapState } from "vuex";
import ModalSkuProducts from "../../components/CrearOS/ModalSkuProducts";
import MantenedorCorreo from "../../components/CrearOS/MantenedorCorreo.vue";
import ModalDirecciones from "../../components/CrearOS/ModalDirecciones.vue";
import MantenedorTelefono from "../../components/CrearOS/MantenedorTelefono";
import store from "@/store";
import {createLogs,getStores} from '../../assets/js/common'
export default {
  name: "Manual",
  data() {
    return {
      typeSku: "",
      showModalProvider: false,
      showModal: false,
      showFormClient: false,
      selectedStoreM: null,
      optionStoresM: [],
      hasError: false,
      messageOS: "",
      boxOne: "",
      optionStores: [],
      clientObservation: "",
      hasData: false,
      filter: {
        valueDocument: "",
      },
      dataManual: [],

      fieldsProviderM: [
        { key: "selected", label: " " },
        { key: "providerName", label: "Proveedor" },
        { key: "capacity", label: "Capacidad" },
        { key: "actions", label: "" },
      ],
      restrictedDaysM: [],
      rowIndex: 0,
      selectedOption: "a",
      optionsProviderM: [],
      isBusyM: false,
      selectModeM: "single",
      request: null,
      dataClient: {},
      selectedPhone: null,
      selectedPhoneSec: null,
      selectedEmail: null,
      selectedDirection: null,
      messageEstimation: "",
    };
  },
  props:{
     idProject:{
      type:Number
    },
    showCambiarFlujo:{
      type: String
    }
  },
  components: {
    ModalOS,
    RegisterClient,
    HeaderGeneric,
    SearchGeneric,
    ObservationInput,
    ModalGeneric,
    DivGeneric,
    ModalSkuComp,
    ModalSkuProducts,
    ModalProvider,
    DetailsOrders,
    MantenedorTelefono,
    MantenedorCorreo,
    ModalDirecciones,
  },
  computed: {
    ...mapState("module", ["store", "username","token"]),
    fullName() {
      let name = this.dataClient.names ? this.dataClient.names : "";
      let lastName = this.dataClient.lastName ? this.dataClient.lastName : "";
      let motherLastName = this.dataClient.motherLastName
        ? this.dataClient.motherLastName
        : "";

      return `${name} ${lastName} ${motherLastName}`;
    },
    isDisabledBtn() {
      if (
        this.dataManual.length == 0 ||
        !this.selectedPhone ||
        !this.selectedDirection ||
        !this.selectedEmail
      )
        return true;
      return false;
    },
    isEnableSearch() {
      if (this.filter.valueDocument) return false;
      return true;
    },
    isVisibleMsgError() {
      if (!this.selectedPhone || !this.selectedDirection || !this.selectedEmail)
        return true;
      return false;
    },
    isVisibleMsgPhone() {
      if (!this.selectedPhone) return true;
      return false;
    },
    isVisibleMsgEmail() {
      if (!this.selectedEmail) return true;
      return false;
    },
    isVisibleMsgDirection() {
      if (!this.selectedDirection) return true;
      return false;
    },
  },
  beforeRouteEnter(to, from, next) {
    let menu = store.getters["module/optionsMenu"];
    let perfil = store.getters["module/profile"];
    let authProvider = menu.some((m) => m.id ==1);
    if (authProvider&&perfil!=="PROVEEDOR") next();
    else next({ name: "BlockedPage" });
  },
  created() {
    this.getStoresCombo();
    this.selectedStoreM = this.store.length ? this.store[0].codigo : null;
  },
  mounted() {
    this.getRestrictedDays();
  },
  methods: {
    onHiddenModalOs() {
      if (this.hasError) this.hasError = false;
    },
    addNewPhone(phone) {
      this.dataClient.phones.push(phone);
      this.selectedPhone = phone;
      this.$bvModal.hide("modal-phone");
    },
    addNewPhoneSec(phone) {
      this.dataClient.phones.push(phone);
      this.selectedPhoneSec = phone;
      this.$bvModal.hide("modal-phone-secondary");
    },
    addNewMail(email) {
      this.dataClient.mails.push(email);
      this.selectedEmail = email;
      this.$bvModal.hide("modal-email");
    },
    addNewDirection(direction) {
      this.dataClient.directions.push(direction);
      this.selectedDirection = direction;
      this.$bvModal.hide("modal-dir");
    },
    resetError() {
      this.messageOS = "";
      this.$bvModal.hide("modal-os");
    },
    onHidden() {
      this.optionsProviderM = [];
      if (!this.isBusyM) return;
      this.request.cancel();
    },
    clearObservation() {
      this.clientObservation = "";
    },
    reset() {
      this.$bvModal.hide("modal-os");
      this.$router.push({ name: "CreacionOs" });
    },
    closeModal() {
      this.$bvModal.hide("modal-pending");
    },
    showConfirmBox() {
      this.boxOne = "";
      this.$bvModal
        .msgBoxConfirm("¿Desea guardar los cambios en el sistema?", {
          title: "",
          size: "sm",
          buttonSize: "sm",
          okVariant: "orange",
          okTitle: "Guardar cambios",
          cancelTitle: "Cancelar",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
          contentClass: "text-center",
        })
        .then((value) => {
          this.boxOne = value;
          if (this.boxOne) {
            this.createOs();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    checkIfProducExist(item) {
      if (item && item.products.length) return true;
      return false;
    },
    resetValues() {
      this.clearObservation();
      if (this.dataManual.length) this.dataManual = [];
      this.hasError = false;
      this.dataClient = {};
      this.selectedPhone = null;
      this.selectedPhoneSec = null;
      this.selectedEmail = null;
      this.selectedEmail = null;
      this.messageOS = "";
    },

    async searchClient() {
      try {
        this.resetValues();
        this.$store.commit("SET_LOADING", true);
        let response = await axios.get(
          process.env.VUE_APP_CLIENT_CORE_BASE +
            "/clients/document/" +
            this.filter.valueDocument,
            {
            headers: {
              "Content-type": "application/json",
              "Authorization": "Bearer "+ this.token
            },
          }
        );
        this.selectedPhone = response.data.phones?.length
          ? response.data.phones[0]
          : null;
        this.selectedEmail = response.data.mails?.length
          ? response.data.mails[0]
          : null;
        this.selectedDirection = response.data.directions?.length
          ? response.data.directions[0]
          : null;
        this.dataClient = response.data;
      } catch (error) {
        if (error.response.status === 400 || error.response.status === 404) {
          this.$bvModal.show("modal-register-client");
        } else {
          this.hasError = true;
          this.messageOS = error.response.data.message;
          this.$bvModal.show("modal-os");
        }
      } finally {
        this.$store.commit("SET_LOADING", false);
      }
    },
    async updateProject(valOs){
      try{
        
        if(this.idProject==null||this.idProject=== undefined) return;
      let response = await axios.put(
          process.env.VUE_APP_PROJECT_BASE + "/" + this.idProject,
          {
            id: this.idProject,
            id_os_instalacion: valOs,
            cotizaciones:[]
          }, // the data to post
          {
            headers: {
              "Content-type": "application/json",
            },
          }
        );
        console.log(response);
        let values = { variant: "success", msg: "Se actualizó exitosamente !" };
        await this.getStatesAndSubStates();
        this.clearValues()
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
      } catch (error) {
        console.log(error);
        let values = { variant: "danger", msg: error.response.data.message };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
      } finally {
        setTimeout(() => this.$store.commit("setShowAlert", false), 3000);
       
      }
    },
    async createOs() {
      try {
        
        const typeOs = this.$route.params.tipo ? this.$route.params.tipo : null;
        let idOsOriginVtec = null;
        let idOsOriginVins = null;
        console.log(this.$route.params.tipo, this.$route.params.id);
        console.log(typeOs);
        if (typeOs == "VI") {
          idOsOriginVins = this.$route.params.id ? this.$route.params.id : null;
        } else if (typeOs == "VTEC") {
          idOsOriginVtec = this.$route.params.id ? this.$route.params.id : null;
          console.log(idOsOriginVtec);
        }

        this.$store.commit("SET_LOADING", true);
        const format = this.dataManual.map((row) => {
          return {
            estimatedDate: row.estimatedDate,
            providerId: row.providerId,
            quantity: row.quantity,
            serviceSku: row.skuService.trim(),
            referenceSku: row.skuProduct.trim(),
            state: row.state,
            turn: row.turn,
            sellerNote: null,
            providerObservation: row.providerObservation,
            voucher: row.voucher,
            folioVoucher: row.folioVoucher,
            idOsOriginVtec: idOsOriginVtec,
            idOsOriginVins: idOsOriginVins,
          };
        });
        let contactIdSec=this.selectedPhoneSec?this.selectedPhoneSec.id:null;
        let response = await axios.post(
          process.env.VUE_APP_ORDER_BUSINESS_BASE + "/orders",
          {
            clientId: this.dataClient.id,
            contactId: this.selectedPhone.id,
            contactIdSecondary:contactIdSec,
            details: format,
            directionId: this.selectedDirection.id,
            emailId: this.selectedEmail.id,
            observation: this.clientObservation,
            registerUser: this.username,
            store: this.selectedStoreM,
            origin: "TIENDA",
          },
          {
            headers: {
              "Content-type": "application/json",
            },
          }
        );
        createLogs(response.config.url,this.username,response.config.method,this.$router.history.current.path);
        this.messageOS = response.data.id;
        this.updateProject(response.data.id)
        console.log(response);
      } catch (error) {
        createLogs(error.response.config.url,this.username,error.response.config.method,this.$router.history.current.path);
        this.hasError = true;
        if (error.response) {
          if (error.response.data.message) {
            this.messageOS = error.response.data.message;
          }
        } else {
          this.messageOS = error.message;
        }
      } finally {
        this.$bvModal.show("modal-os");
        this.$store.commit("SET_LOADING", false);
      }
    },
    /* async getStores() {
      try {
        let response = await axios.get(
          process.env.VUE_APP_ENDPOINT_TIENDAS_BASE + "?limit=100"
        );
        let filteredStores = response.data
          .filter((f) => f.isStore === "true")
          .sort((a, b) => a.storeCode - b.storeCode);
        const data = filteredStores.map((row) => {
          return {
            value: row.storeCode,
            text: row.storeCode + "-" + row.fullName,
          };
        });
        this.optionStoresM = data;
      } catch (error) {
        console.error(error);
      }
    }, */
    async getStoresCombo() {
      try {
        let data = await getStores();
        
        
        this.optionStoresM = data;
      } catch (error) {
        console.error(error);
      }
    },
    //services-manual
    addDetailOS() {
      this.dataManual.push({
        folioVoucher: "",
        voucher: "",
        skuService: "",
        skuProduct: "",
        quantity: 1,
        estimatedDate: "",
        turn: null,
        providerName: "",
        providerId: null,
        providerObservation: "",
        descriptionSku: "",
        descriptionSkuProduct: "",
        state: "PENDIENTE_CREACION",
        isSaved: false,
      });
    },

    async getRestrictedDays() {
      try {
        let response = await axios.get(
          process.env.VUE_APP_RESTRICTIONS_BASE +
            "/restricted_days/dates?dateFormat=yyyy-MM-dd"
        );
        this.restrictedDaysM = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    /*openOptionsSearch(index) {
      this.rowIndex = index;
      this.$bvModal.show("modal-options-v1");
    },*/
    openModalService(index) {
      this.rowIndex = index;
      this.$bvModal.show("modal-service");
    },

    openOptionSelected() {
      /* if (this.selectedOption == "a") {
        this.$bvModal.show("modal-product");
      } else {
        this.$bvModal.show("modal-cp");
      } */
      this.$bvModal.show("modal-cp");
    },
    setSkuCp(selected, data) {
      let comprobante = `pos:${data.caja},date:${data.fecha},seq:${data.secuencia},store:${data.selectedStore}`;

      this.dataManual[this.rowIndex].state = "INGRESADA";

      this.dataManual[this.rowIndex].voucher = comprobante;
      this.dataManual[this.rowIndex].folioVoucher = selected[0].folio;
      if (this.typeSku === "PRODUCT") {
        this.dataManual[this.rowIndex].skuProduct = selected[0].sku;
        this.dataManual[this.rowIndex].descriptionSkuProduct =
          selected[0].description;
        this.dataManual[this.rowIndex].quantity = selected[0].quantity;
      } else {
        this.dataManual[this.rowIndex].skuService = selected[0].sku;
        this.dataManual[this.rowIndex].descriptionSku = selected[0].description;
        this.dataManual[this.rowIndex].quantity = selected[0].quantity;
      }
    },

    setValuesClient(selected) {
      //this.filter.valueDocument = selected.document;
      this.hasData = selected.show;
      this.dataClient = selected.data;
      this.selectedPhone = selected.data.phones
        ? selected.data.phones[0]
        : null;
      this.selectedEmail = selected.data.mails ? selected.data.mails[0] : null;
      this.selectedDirection = selected.data.directions
        ? selected.data.directions[0]
        : null;
    },
    setSelectedProduct(selected) {
      this.dataManual[this.rowIndex].skuProduct = selected[0].sku;
      this.dataManual[this.rowIndex].descriptionSkuProduct =
        selected[0].description;
    },
    selectRowProvider(items) {
      this.dataManual[this.rowIndex].providerName = items.providerName;
      this.dataManual[this.rowIndex].providerId = items.providerId;
      this.showModalProvider = false;
    },
  },
};
</script>
<style scoped>
.input-group-addon:first-child {
  border-left-width: 1px;
}
.input-group-addon:last-child {
  border-right-width: 1px;
}
.input-group-addon-orange {
  border-right-width: 1px;
  border-right: 1px solid orange;
}
::v-deep .modal-header {
  border-bottom: none !important;
}
::v-deep #modal-os .modal-header {
  display: none;
}

::v-deep #modal-pending .modal-footer {
  align-items: center;
}
::v-deep #modal-pending .modal-footer button {
  background: orange;
}

::v-deep #modal-options-v1___BV_modal_header_ {
  display: none;
}
::v-deep #modal-options-v1___BV_modal_body_ {
  text-align: center;
}
.padding-four-top {
  margin-top: 3%;
}
::v-deep .table td {
  color: black;
  font-size: 14px;
  border-top: 1px solid #ff8000 !important;
}
</style>